<mat-card class="no-offers-card">
  <mat-card-header>
    <mat-card-title class="no-offers-title">
      😕 Something went wrong
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="no-offers-message">
      <p class="error-message">
        {{ errorMessage() }}
      </p>

      <p>
        Please feel free to call us at
        <a href="tel:1800994412"><b>1800 994 412</b></a> if you have any
        questions regarding your booking. We’re here to help and look forward to
        hearing from you soon.
      </p>
    </div>
  </mat-card-content>
</mat-card>
